import { render, staticRenderFns } from "./ShiftPlacement.vue?vue&type=template&id=0aa123d0&scoped=true&"
import script from "./ShiftPlacement.vue?vue&type=script&lang=js&"
export * from "./ShiftPlacement.vue?vue&type=script&lang=js&"
import style0 from "./ShiftPlacement.vue?vue&type=style&index=0&id=0aa123d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa123d0",
  null
  
)

export default component.exports